import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import classNames from 'classnames'
import Modules from '../../components/modules'

import withModules from '../../containers/with-modules'
import withCentreSelector from '../../containers/with-centre-selector'
import Feature from '../../components/feature'
import pagesHoc from '../pages-hoc'
import getUtilityPanelModule from '../../helpers/get-utility-panel-module'
import { withAngleClasses } from '../../helpers/with-angle'
import { PromotionPositionContext, useEvolvedContext } from '../../context'
import styles from './index.module.scss'

const Home = ({ modules, centre, animate, angleClasses }) => {
  const isEvolved = useEvolvedContext()
  const featureModule = modules[0]
  const templateModules = modules.slice(1)
  const utilityPanelModule = getUtilityPanelModule(centre, templateModules)

  const templateModulesWithoutUtilityPanel = [...templateModules]
  templateModulesWithoutUtilityPanel.splice(
    templateModulesWithoutUtilityPanel.indexOf(utilityPanelModule),
    1
  )

  return (
    <div className={classNames({ [styles.evolved]: isEvolved })}>
      <PromotionPositionContext.Provider
        value={featureModule.analyticsMetadata?.displayId}
      >
        {isEvolved && (
          <div
            className={classNames(
              styles.background,
              angleClasses['bottom-left']
            )}
          />
        )}
        <Feature
          {...featureModule}
          isTopFeature
          lazyLoad={false}
          utilityPanelModule={utilityPanelModule}
          withMask={animate}
          analyticsMetadata={featureModule.entryAnalyticsMetadata}
        />
      </PromotionPositionContext.Provider>
      <MediaQuery maxWidth={927}>
        <Modules
          useDeckBG
          initialColor="Grey"
          initialAngle="top-left"
          className={styles.initialContentGroup}
          modules={templateModules}
          centreTitle={centre.title}
        />
      </MediaQuery>
      <MediaQuery minWidth={928}>
        <Modules
          useDeckBG
          initialColor="Grey"
          initialAngle="top-left"
          className={styles.initialContentGroup}
          modules={templateModulesWithoutUtilityPanel}
          centreTitle={centre.title}
        />
      </MediaQuery>
    </div>
  )
}

Home.propTypes = {
  modules: PropTypes.array,
  promotionContent: PropTypes.object,
  template: PropTypes.object,
  centre: PropTypes.object,
  animate: PropTypes.bool,
  angleClasses: PropTypes.object,
}

Home.defaultProps = {
  modules: [],
}

export default withAngleClasses(withCentreSelector(withModules(pagesHoc(Home))))
